import React from 'react'
import { useQueries } from '@tanstack/react-query'

import { AuctionLightDTO } from 'models/dtos'
import { currentQueryService } from 'utils/api/queries'
import { generateAuctionLib } from 'utils/helpers'
import { useCompanies } from 'contexts/CompaniesContext'
import { useAlert } from 'contexts/AlertContext'

const useGetAuctionsLight = (timeLine: 'past' | 'future') => {
  const { filteringCompaniesIds } = useCompanies()
  const { displayAlert } = useAlert()

  const results = useQueries({
    queries: filteringCompaniesIds.map((entityId) => ({
      queryKey: ['useGetAuctionsLight', entityId, timeLine],
      queryFn: () =>
        entityId ? currentQueryService.getAuctionsLight(entityId, timeLine) : Promise.resolve([]),
      retry: false,
    })),
  })

  const isLoading = results.some((result) => result.isLoading)
  const isError = results.some((result) => result.isError)
  const isPending = results.some((result) => result.isPending)

  React.useEffect(() => {
    if (isError) {
      displayAlert(
        `Erreur lors du chargement des ventes ${timeLine === 'future' ? 'futures.' : 'passées.'}`,
        'error',
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError])

  const rawData: AuctionLightDTO[] =
    isError || isPending
      ? []
      : results
          .map((result) => result.data || [])
          .flat()
          .reduce<AuctionLightDTO[]>((acc, item) => {
            if (!acc.find((existing) => existing.no === item.no)) {
              acc.push(item)
            }
            return acc
          }, [])

  const data = isError ? [] : rawData.map((auctionLight) => generateAuctionLib(auctionLight))

  return { data, isLoading, isError }
}

export { useGetAuctionsLight }
